module.exports = __webpack_public_path__ + "static/media/pop-transparent.1424ef1a.png";